import { Box, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import { ReactComponent as TicketingIcon } from "../../../../../icons/icon_files/new_ticket.svg";
import PotentialCollapsibleSection from "./PotentialCollapsibleSection";

export const TICKETING_SECTION_CLASSNAME = "ticketing-section";

export default function TicketingSection({ displayName }) {
  const colors = useColors();
  return (
    <PotentialCollapsibleSection title="Ticketing" Icon={TicketingIcon}>
      <div
        className={TICKETING_SECTION_CLASSNAME}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "8px 0",
        }}
      >
        <Box display="flex" gap={1} flexDirection="column">
          <Typography variant="body2" color={colors.text_primary}>
            Integrating {displayName} into Breeze streamlines remediation
            tracking by linking validated findings to {displayName} issues,
            ensuring visibility into remediation progress across security and
            operations teams.
          </Typography>
        </Box>
      </div>
    </PotentialCollapsibleSection>
  );
}
